


















































































































import { LoginVue } from "fs-pb-vue2/vueModels/auth/LoginVue";
import { Component, Watch } from "vue-property-decorator";
import BackLink from "@/components/app/BackLink.vue";
import EbsStart from "@/components/ebs/EbsStart.vue";
import VerifyBox from "@/components/app/VerifyBox.vue";
import LoginWithoutPassword from "@/components/auth/LoginWithoutPassword.vue";

@Component({
  components: { BackLink, EbsStart, VerifyBox, LoginWithoutPassword }
})
export default class Login extends LoginVue {

  loginWithoutPasswordOnProps: boolean = false;

  constructor() {
    super();
    this.loginWithoutPasswordOnProps = this.loginWithoutPasswordOn && this.isMobileBrowser;
  }
  /**
 * Признак входа без логина/пароля
 */
  get loginWithoutPasswordOn(): boolean {
    return window.localStorage.getItem('loginWithoutPasswordOn') === "1"
      && !!window.localStorage.getItem('deviceId')
      && !!window.localStorage.getItem('loginValue');
  }

  
  /**
   * Признак мобильного браузера
   */
   get isMobileBrowser(): boolean {
    const userAgent = navigator.userAgent;
    const mobileRegExp = /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i;
    return mobileRegExp.test(userAgent);
  }

  
  closeLoginWithoutPassword() {
    window.localStorage.setItem('loginWithoutPasswordOn', undefined);
    this.loginWithoutPasswordOnProps = false;
  }

  onLoginWithoutPassword = async (pin: string) => {
    if (this.appStore.loading)
      return

    this.appStore.setLoading(true);

    const login = window.localStorage.getItem('loginValue');
    const devId =  window.localStorage.getItem('deviceId');

    if(!login || !pin || !devId) {
      this.loginWithoutPasswordOnProps = false;
      return;
    }
    this.model.DevId = devId;
    this.model.Pin = pin;
    this.model.Login = login;

    this.model = await this.authService.login(this.model);
    if (this.model.IsSuccess) {
      window.localStorage.setItem('loginValue', this.model.Login)
      this.alertService.clear();
      const returnUrl = this.$route.query.returnUrl || "/";
      this.$router.push(returnUrl);
    } else {
      this.appStore.setLoading(false);
    }
  }

  ebsDialog: boolean = false;

  @Watch('loginValue', { immediate: true })
  loginChanged(val: string): void {
    if (val && val.length)
      this.model.Login = val.replaceAll('(', '').replaceAll(')', '').replaceAll(' ', '').replaceAll('-', '');
  }

  loginValue: string = '';

  async mounted() {
    await this.init();
  }

  showEbsDialog(): void {
    this.ebsDialog = true;
  }
  hideEbsDialog(): void {
    this.ebsDialog = false;
  }

  validateForm(): void {
    // Проверяем форму на валидность
    (this.$refs.form as any).validate();
  }

  resetFormValidation(): void {
    // Сбрасываем реззультаты валидации
    (this.$refs.form as any).resetValidation();
  }
}
